(() => {
  document.querySelectorAll('.clinic-gallery').forEach(gallery => {
    const swiper = new Swiper(gallery.querySelector('.clinic-gallery-items'), {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        enabled: true,
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        enabled: true,
        el: '.swiper-pagination',
        type: 'progressbar'
      }
    });

    swiper.on('activeIndexChange', () => {
      gallery.querySelectorAll('.clinic-gallery-thumbnail').forEach(thumb => {
        if (thumb.dataset.slideIndex == swiper.activeIndex) {
          thumb.classList.add('active');
        } else {
          thumb.classList.remove('active');
        }
      });
    });

    gallery.querySelectorAll('.clinic-gallery-thumbnail').forEach(thumb => {
      thumb.addEventListener('click', e => {
        e.preventDefault();

        swiper.slideTo(thumb.dataset.slideIndex);
      });
    });

    gallery.querySelectorAll('.clinic-gallery-item-video').forEach(video => {
      video.querySelector('.clinic-gallery-item-video-image').addEventListener('click', e => {
        video.classList.add('show');
        video.querySelector('video').play();
      });
    });
  });
})();